<template>
  <div>
    <Header />
    <div class="breadcrumb-area gray-bg">
      <div class="container">
        <div class="breadcrumb-content">
          <ul>
            <li><router-link to="/">Home</router-link></li>
						 <li><router-link to="/account">Account</router-link></li>
            <li class="active">My Tickets</li>
          </ul>
        </div>
      </div>
    </div>
    <template>
      <div class="myaccount-area pb-50 pt-50">
        <div class="container">
					<h3 class="page-title">My Tickets</h3>

					<div class="testimonial-style-2 event-container pl-2 mb-4" v-for="ticket in tickets" :key="ticket.id">
						<div class="bg-white p-2">
							<div class="row">
								<div class="col-lg-2 col-12 d-flex align-items-center justify-content-center py-2">
										<img alt="Event-Poster" class="event-avatar" :src="serverURL + '/storage/events/' + ticket.event.main_photo" height="10%">
								</div>
								<div class="col-lg-10 pt-2">
									<div class="row">
										<div class="col-lg-4 col-12">
											<div class="testimonial-2-content">
													<div class="testimonial-2-name">
															<h3 class="event-title-ticket">{{ticket.event.name}}</h3>
													</div>
											</div>
										</div>

										<div class="col-lg-4 col-6">
											<div class="testimonial-2-content">
													<div class="testimonial-2-name">
															<h5>{{ticket.sale_date}}</h5>
													</div>
											</div>
										</div>
								
										<div class="col-lg-4 col-6">
											<div class="testimonial-2-content">
													<div class="testimonial-2-name">
															<h5 class="ticket-page-mobile">KSh. {{ticket.amount}}</h5>
													</div>
											</div>
									</div>
									</div>

									<div class="row">
										<div class="col-lg-4 col-6">
											<div class="testimonial-2-content">
													<div class="testimonial-2-name">
															<h5>{{ticket.name}}</h5>
													</div>
											</div>
										</div>
										<div class="col-lg-4 col-6">
											<div class="testimonial-2-content">
													<div class="testimonial-2-name">
															<h5 class="ticket-page-mobile">{{ticket.buyer}}</h5>
													</div>
											</div>
										</div>
										<div class="col-lg-4 col-6">
											<div class="testimonial-2-content">
													<div class="testimonial-2-name">
															<a target="_blank" :href="host + '/t/' + ticket.ticket_url"><h5><u>View Ticket</u></h5></a>
													</div>
											</div>
										</div>
									</div>
								</div>
							</div>				
						</div>	
					</div>
					
        </div>
      </div>
    </template>
    <Footer />
  </div>
</template>

<script>
  import Header from "../components/Header.vue";
  import Footer from "../components/Footer.vue";
  import { mapState, mapActions } from "vuex";
  import Tickets from "../apis/tickets";
  import { config } from '../util/config'

  export default {
    name: "Home",
    components: {
      Header,
      Footer,
    },

    computed: {
      ...mapState("auth", ["userData"]),  
    },

    data() {
      return {
				host: window.location.origin,
        serverURL: config.backendURL,
        tickets: {},
      };
    },

    created: function () {
      this.fetchTickets();
    },

    methods: {
			
      fetchTickets() {
        var that = this;
        var data = {};
        data = this.userData.user.id;

        Tickets.myTickets(data)
          .then((response) => {          
            that.tickets = response.data

						console.log(that.tickets)
          })
          .catch(function (error) {
						that.errorAlert = true;
            alert(error)
          });
      },

      getOrderItems(order) {
          this.order = order
          this.orderItems = order.order_items
      }
    },
  };
</script>